import mapBoundariesDirective from "./map-boundaries-directive";

export {mapBoundariesDirective};
